export default "__VITE_ASSET__awqQkKY8__"